import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-upload.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const UploadIcon = createSvgIcon(<Icon />, 'UploadIcon');
